/**
 * UnitsModal — página completa de Unidades embebida en un Dialog.
 *
 * Se abre cuando una patente de camión o carreta no es encontrada en SmartGT.
 * Pre-carga el buscador con la patente y permite buscar, editar o crear unidades.
 */

import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog"
import { AlertTriangleIcon } from "lucide-react"
import { UnitsTable } from "@/pages/units/UnitsTable"

interface Props {
  open: boolean
  onClose: () => void
  defaultSearch?: string
  alertType?: "truck" | "trailer" | undefined
}

export function UnitsModal({ open, onClose, defaultSearch = "", alertType }: Props) {
  const alertLabel = alertType === "trailer" ? "carreta" : "camión"

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose() }}>
      <DialogContent className="max-w-5xl w-full max-h-[90vh] flex flex-col p-0 gap-0">
        <DialogHeader className="px-6 pt-5 pb-4 border-b shrink-0">
          <DialogTitle>Unidades</DialogTitle>
          {defaultSearch && (
            <div className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800 px-3 py-2 text-sm text-amber-800 dark:text-amber-300 mt-2">
              <AlertTriangleIcon className="size-4 shrink-0" />
              <span>
                La patente de {alertLabel}{" "}
                <span className="font-mono font-semibold">{defaultSearch}</span>{" "}
                no está registrada. Buscá la unidad y editala para agregar este código SGT, o creá una nueva.
              </span>
            </div>
          )}
        </DialogHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          <UnitsTable defaultSearch={defaultSearch} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
